import { useState } from "react";
import { API_BASE_URL } from "../../utilities/constants";
import { handleApiCall } from "../../utilities/helper";
import img from "../../assets/defaultlook.png"
import { useNavigate } from "react-router";


const GeneratedLooksCard = ({ look, stylist }) => {
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const handleViewOutfit = (itemId = null) => {
        navigate(`/outfit-details/${look?.lookId}`, { state: { look, selectedItemId: itemId } });
    };

    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden flex flex-col h-full">
            <div className="relative w-full flex-1 overflow-hidden">
                <img
                    src={look?.imageUrl ? look.imageUrl : img}
                    alt={look.style || "look image"}
                    className="w-full h-full object-cover"
                />
                <span
                    className={`absolute top-2 right-2 text-white text-xs px-2 py-1 rounded-md
                    ${look?.status === "FAILED" ? "bg-error-500" : "bg-success-500"}
                    `}
                >
                    {look?.status}
                </span>
                {look?.similarityScore != null && (
                    <div className="absolute bottom-2 left-2 bg-black/70 backdrop-blur-md text-white text-[10px] px-1.5 py-0.5 rounded-md font-medium">
                        {Number(look.similarityScore).toFixed(2) + "% Similar"}
                    </div>
                )}
            </div>
            <div className="p-4 flex flex-col">
                {/* TEXT (LEFT LABEL – RIGHT VALUE) */}
                <div className="mb-3">
                    <div className="grid grid-cols-[auto_minmax(80px,1fr)] gap-x-6 gap-y-2 items-center">


                        <span className="text-sm text-gray-500 text-left">
                            Vibe
                        </span>
                        <span className="text-sm text-gray-500 text-right">
                            {look?.vibe || "-"}
                        </span>

                        <span className="text-sm text-gray-500 text-left">
                            Stylist
                        </span>
                        <span className="text-sm text-gray-500 text-right">
                            {look?.stylist ? look?.stylist : stylist?.label || "-"}
                        </span>

                    </div>
                </div>
                <button
                    onClick={look?.status === "READY" ? () => handleViewOutfit(null) : undefined}
                    className={`w-full text-sm font-medium rounded-md px-4 py-2 transition-all
                        ${look?.status === "READY"
                            ? "bg-brand-600 hover:bg-brand-700 text-white"
                            : "bg-gray-300 text-gray-600 cursor-not-allowed"
                        }
      `          }
                >
                    {loading ? "Loading Outfit..." : "View Outfit"}
                </button>
            </div>
        </div >
    );
};
export default GeneratedLooksCard;
